import React from 'react';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface JDSTooltipProps {
	toolIcon: JSX.Element;
}

export function JDSTooltip({ toolIcon }: Readonly<JDSTooltipProps>): JSX.Element {
	return (
		<S.CustomContainerTooltip>
			{toolIcon}
			<S.ContentTool isJDS_D86={true}>
				<h4>{I18n.get('Vibration risk classification (JDS-D86)')}</h4>
			</S.ContentTool>
		</S.CustomContainerTooltip>
	);
}
